module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-toc",
    attrs: {
      "id": "table-of-contents"
    }
  }, [_c('div', {
    staticClass: "heading heading-container-single heading-size-small heading-format-reduced heading-alignment-fixed heading-without-image"
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "element-title case-mixed"
  }, [_vm._v("Contents")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-contents text"
  }, [_c('div', {
    staticClass: "toc-frontmatter-group"
  }, [_c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/foreword"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text"
  }, [_vm._v("Foreword")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-bodymatter-group"
  }, [_c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/theyoungking"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text"
  }, [_vm._v("The Young King")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/thebirthdayoftheinfanta"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text"
  }, [_vm._v("The Birthday of the Infanta")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/thefishermanandhissoul"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text"
  }, [_vm._v("The Fisherman and His Soul")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/thestarchild"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text"
  }, [_vm._v("The Star-Child")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/publishersnote"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text"
  }, [_vm._v("Publisher’s Note")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-backmatter-group"
  }, [_c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text"
  }, [_vm._v("Acknowledgments")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/abouttheauthor"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text"
  }, [_vm._v("About the Author")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/abouttheeditor"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text"
  }, [_vm._v("About the Editor")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/wordfireclassics"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text"
  }, [_vm._v("WordFire Classics")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0faf4820","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 66
// module chunks = 0